import { render, staticRenderFns } from "./ServiceRecordStep3.vue?vue&type=template&id=5e38e204&scoped=true"
import script from "./ServiceRecordStep3.vue?vue&type=script&lang=js"
export * from "./ServiceRecordStep3.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecordStep3.vue?vue&type=style&index=0&id=5e38e204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e38e204",
  null
  
)

export default component.exports